
// @ts-nocheck
import locale__app_node_modules__64basecom_gmbh_pond_i18n_de_DE_de_DE_ts from "../../../@basecom-gmbh/pond/i18n/de-DE/de-DE.ts";
import locale__app_i18n_de_DE_de_DE_ts from "../../../../i18n/de-DE/de-DE.ts";
import locale__app_node_modules__64basecom_gmbh_pond_i18n_en_GB_en_GB_ts from "../../../@basecom-gmbh/pond/i18n/en-GB/en-GB.ts";
import locale__app_i18n_en_GB_en_GB_ts from "../../../../i18n/en-GB/en-GB.ts";
import locale__app_i18n_fr_FR_fr_FR_ts from "../../../../i18n/fr-FR/fr-FR.ts";


export const localeCodes =  [
  "de-DE",
  "en-GB",
  "fr-FR"
]

export const localeLoaders = {
  "de-DE": [{ key: "../../../@basecom-gmbh/pond/i18n/de-DE/de-DE.ts", load: () => Promise.resolve(locale__app_node_modules__64basecom_gmbh_pond_i18n_de_DE_de_DE_ts), cache: true },
{ key: "../../../../i18n/de-DE/de-DE.ts", load: () => Promise.resolve(locale__app_i18n_de_DE_de_DE_ts), cache: true }],
  "en-GB": [{ key: "../../../@basecom-gmbh/pond/i18n/en-GB/en-GB.ts", load: () => Promise.resolve(locale__app_node_modules__64basecom_gmbh_pond_i18n_en_GB_en_GB_ts), cache: true },
{ key: "../../../../i18n/en-GB/en-GB.ts", load: () => Promise.resolve(locale__app_i18n_en_GB_en_GB_ts), cache: true }],
  "fr-FR": [{ key: "../../../../i18n/fr-FR/fr-FR.ts", load: () => Promise.resolve(locale__app_i18n_fr_FR_fr_FR_ts), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../../../@basecom-gmbh/pond/i18n.config.ts?hash=5f5e2614&config=1" /* webpackChunkName: "__i18n_config_ts_5f5e2614" */),
  () => import("../../../../i18n.config.ts?hash=99279338&config=1" /* webpackChunkName: "__i18n_config_ts_99279338" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "de-DE",
      "files": [
        "/app/node_modules/@basecom-gmbh/pond/i18n/de-DE/de-DE.ts",
        "/app/i18n/de-DE/de-DE.ts"
      ]
    },
    {
      "code": "en-GB",
      "files": [
        "/app/node_modules/@basecom-gmbh/pond/i18n/en-GB/en-GB.ts",
        "/app/i18n/en-GB/en-GB.ts"
      ]
    },
    {
      "code": "fr-FR",
      "files": [
        "/app/i18n/fr-FR/fr-FR.ts"
      ]
    }
  ],
  "defaultLocale": "de-DE",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "de-DE",
    "files": [
      {
        "path": "/app/node_modules/@basecom-gmbh/pond/i18n/de-DE/de-DE.ts"
      },
      {
        "path": "/app/i18n/de-DE/de-DE.ts"
      }
    ]
  },
  {
    "code": "en-GB",
    "files": [
      {
        "path": "/app/node_modules/@basecom-gmbh/pond/i18n/en-GB/en-GB.ts"
      },
      {
        "path": "/app/i18n/en-GB/en-GB.ts"
      }
    ]
  },
  {
    "code": "fr-FR",
    "files": [
      {
        "path": "/app/i18n/fr-FR/fr-FR.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
